<p-toast />
<p-confirmDialog />
<app-page-layout
  [pageTitle]="user()?.name || 'User'"
  subtitle="User details"
>
  <!-- State Container -->
  <app-state-container
    [state]="viewState()"
    loadingMessage="Loading user details..."
    loadingSubMessage="Please wait while we fetch the user information"
    emptyIcon="pi-user"
    emptyTitle="User not found"
    [emptyMessage]="emptyStateMessage()"
    [showEmptyAction]="false"
    [showClearFilters]="false"
    [errorMessage]="errorMessage()"
    (retry)="retryLoad()"
  >
    @if (user(); as u) {
      <div class="p-4 space-y-4">

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

          <div class="p-3 rounded-lg border border-surface-200 dark:border-surface-700 bg-surface-50 dark:bg-surface-900">
            <span class="text-surface-500 dark:text-surface-400">Name</span>
            <div class="font-medium text-surface-900 dark:text-surface-100">{{ u.name }}</div>
          </div>

          <div class="p-3 rounded-lg border border-surface-200 dark:border-surface-700 bg-surface-50 dark:bg-surface-900">
            <span class="text-surface-500 dark:text-surface-400">Username</span>
            <div class="font-medium text-surface-900 dark:text-surface-100">{{ u.username }}</div>
          </div>

          <div class="p-3 rounded-lg border border-surface-200 dark:border-surface-700 bg-surface-50 dark:bg-surface-900">
            <span class="text-surface-500 dark:text-surface-400">Email</span>
            <div class="font-medium text-surface-900 dark:text-surface-100">{{ u.email }}</div>
          </div>

          <div class="p-3 rounded-lg border border-surface-200 dark:border-surface-700 bg-surface-50 dark:bg-surface-900">
            <span class="text-surface-500 dark:text-surface-400">Mobile</span>
            <div class="font-medium text-surface-900 dark:text-surface-100">{{ u.mobile || '-' }}</div>
          </div>

          <div class="p-3 rounded-lg border border-surface-200 dark:border-surface-700 bg-surface-50 dark:bg-surface-900">
            <span class="text-surface-500 dark:text-surface-400">Org ID</span>
            <div class="font-medium text-surface-900 dark:text-surface-100">{{ u.orgId }}</div>
          </div>

          <div class="p-3 rounded-lg border border-surface-200 dark:border-surface-700 bg-surface-50 dark:bg-surface-900">
            <span class="text-surface-500 dark:text-surface-400">Status</span>
            <div>
              <span
                class="px-2 py-0.5 rounded text-xs font-medium"
                [ngClass]="{
                  'bg-green-100 text-green-700 dark:bg-green-500/20 dark:text-green-300': u.enabled,
                  'bg-gray-200 text-gray-600 dark:bg-surface-700 dark:text-surface-300': !u.enabled
                }"
              >
                {{ u.enabled ? 'Active' : 'Inactive' }}
              </span>
            </div>
          </div>

          <div class="p-3 rounded-lg border border-surface-200 dark:border-surface-700 bg-surface-50 dark:bg-surface-900">
            <span class="text-surface-500 dark:text-surface-400">Created</span>
            <div class="font-medium text-surface-900 dark:text-surface-100">
              {{ u.createdDate | date:'dd MMM yyyy, hh:mm a' }}
            </div>
          </div>

        </div>

        <p-accordion
          [multiple]="true"
          [value]="['0']"
          [style]="{'--p-accordion-content-padding': '0px','--p-accordion-header-padding':'1.125rem 0'}"
        >
          <p-accordion-panel value="0" class="p-3 rounded-lg border border-surface-200 dark:border-surface-700 bg-surface-50 dark:bg-surface-900">
            <p-accordion-header>
              <div class="flex items-center gap-2">
                <i class="pi pi-th-large text-primary-600 dark:text-primary-400"></i>
                <span class="font-medium">Assigned Applications</span>
                @if (assignedApplications().length > 0) {
                  <span class="ml-1 px-2 py-0.5 rounded-full text-xs bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300">
                    {{ assignedApplications().length }}
                  </span>
                }
              </div>
            </p-accordion-header>

            <p-accordion-content>
              <div class="space-y-4 pt-2">
                <div class="flex items-end gap-2">
                  <div class="w-80 max-w-full">
                    <label class="block text-sm font-medium text-surface-700 dark:text-surface-300 mb-2">
                      Select Application to Assign
                    </label>
                    <p-select
                      [options]="availableOptions"
                      [ngModel]="selectedApplicationId()"
                      (ngModelChange)="onApplicationSelectChange($event)"
                      optionLabel="name"
                      optionValue="id"
                      placeholder="Choose an application..."
                      [filter]="true"
                      filterBy="name,code"
                      [showClear]="true"
                      [loading]="loadingApplications()"
                      appendTo="body"
                      styleClass="w-full"
                    >
                      <ng-template let-app pTemplate="item">
                        <div class="flex items-center gap-2">
                          <i class="pi pi-th-large text-surface-400"></i>
                          <span>{{ app.name }}</span>
                          @if (app.code) {
                            <span class="text-xs text-surface-400">({{ app.code }})</span>
                          }
                        </div>
                      </ng-template>

                      <ng-template let-app pTemplate="selectedItem">
                        <div class="flex items-center gap-2">
                          <i class="pi pi-th-large text-surface-400"></i>
                          <span>{{ app.name }}</span>
                        </div>
                      </ng-template>
                    </p-select>
                  </div>
                  <button
                    pButton
                    type="button"
                    label="Add"
                    icon="pi pi-plus"
                    class="p-button-primary"
                    [disabled]="selectedApplicationId() === null || assigningApplications()"
                    [loading]="assigningApplications()"
                    (click)="addApplications()"
                  ></button>
                </div>
                @if (assignedApplications().length > 0) {
                  <div class="bg-white dark:bg-zinc-950 rounded-lg border border-surface-200 dark:border-zinc-800">
                    <p-table
                      [value]="assignedApplications()"
                      dataKey="id"
                      class="p-datatable-sm"
                      [resizableColumns]="true"
                      columnResizeMode="fit"
                      [rowHover]="true"
                      [loading]="loadingAssignedApps()"
                    >
                      <ng-template pTemplate="header">
                        <tr class="bg-surface-100 dark:bg-zinc-900 text-surface-600">
                          <th
                            pResizableColumn
                            style="min-width:200px;"
                            class="text-left bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200"
                          >
                            Application
                          </th>
                          <th
                            pResizableColumn
                            style="min-width:140px;"
                            class="text-left bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200"
                          >
                            Code
                          </th>
                          <th
                            pResizableColumn
                            style="min-width:220px;"
                            class="text-left bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200"
                          >
                            Client ID
                          </th>
                          <!-- <th
                            pResizableColumn
                            style="min-width:220px;"
                            class="text-left bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200"
                          >
                            Status
                          </th> -->
                          <th
                            pResizableColumn
                            style="min-width:100px;"
                            class="bg-surface-100 dark:bg-zinc-900 text-surface-700 dark:text-zinc-200"
                          >
                            Actions
                          </th>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="body" let-app>
                        <tr class="border-t border-surface-200 dark:border-surface-700 hover:bg-surface-50 dark:hover:bg-surface-800 transition">
                          <td class="py-2">
                            <div class="flex items-center gap-2">
                              <span class="font-medium text-surface-900 dark:text-surface-100">{{ app.name }}</span>
                            </div>
                          </td>

                          <td class="py-2">
                            <span class="px-2 py-0.5 rounded text-xs bg-surface-100 dark:bg-surface-800 text-surface-600 dark:text-surface-300 ">
                              {{ app.code || '-' }}
                            </span>
                          </td>

                          <td class="py-2 text-sm text-surface-700 dark:text-surface-300 ">
                            {{ app.clientId || '-' }}
                          </td>

                          <!-- <td class="py-2 text-sm text-surface-700 dark:text-surface-300 ">
                             @if (app.active) { Active } @else { Inactive }
                          </td> -->

                          <td class="py-2">
                            <button
                              pButton
                              class="pi pi-trash p-button-rounded p-button-text p-button-sm"
                              severity="danger"
                              (click)="removeApplication(app)"
                              pTooltip="Remove"
                              tooltipPosition="top"
                            ></button>
                          </td>
                        </tr>
                      </ng-template>

                      <ng-template pTemplate="emptymessage">
                        <tr>
                          <td colspan="4" class="text-center py-6 text-surface-500 dark:text-surface-400">
                            No applications assigned yet.
                          </td>
                        </tr>
                      </ng-template>
                    </p-table>
                  </div>
                } @else {
                  <div class="text-center py-8 border border-dashed border-surface-300 dark:border-surface-600 rounded-lg">
                    <i class="pi pi-th-large text-3xl text-surface-300 dark:text-surface-600"></i>
                    <p class="mt-2 text-sm text-surface-500 dark:text-surface-400">
                      No applications assigned yet. Select from the dropdown above and click Add.
                    </p>
                  </div>
                }

              </div>
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>

      </div>
    }
  </app-state-container>
</app-page-layout>